import Header from "./header/header";
import Footer from "./footer/footer";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <>
      <Header />
      <main className="overflow-hidden">
        <Outlet />
      </main>
      <Footer />
      
    </>
  );
}